import PropTypes from "prop-types";
import React, { useEffect, useState } from "react"


import './dashboard.scss'


//i18n
import { withTranslation } from "react-i18next";
import MySubscription from "pages/Dashboard/MySubscription";

// import { FaExpand, FaTimes } from 'react-icons/fa';
const SubscriptionHistory = props => {
  //meta title
  document.title = "My subscription | ICE - Student Portal";
  return (
    <React.Fragment>
      <div className="page-content" style={{ position: 'relative' }}>
            <MySubscription />
      </div>
    </React.Fragment>
  );
};

SubscriptionHistory.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(SubscriptionHistory);
